import { render, staticRenderFns } from "./children-bank-statements.vue?vue&type=template&id=431191b8&"
import script from "./children-bank-statements.vue?vue&type=script&lang=js&"
export * from "./children-bank-statements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports